module.exports = __webpack_public_path__ + "images/category_lp/alcohol/banner_a48cd56527299687093dbb5e8f389a48.png";